import { render, staticRenderFns } from "./p-privacy-policy.vue?vue&type=template&id=367d4cb0&"
import script from "./p-privacy-policy.vue?vue&type=script&lang=js&"
export * from "./p-privacy-policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports